import { CognitiveDomain } from "types/api";
import { AccordionSection } from "./types";

export const accordionData: AccordionSection[] = [
  {
    title: "INSTRUCTIONS",
    content: [
      CognitiveDomain.Intro,
      CognitiveDomain.Outro,
      CognitiveDomain.RecordingFeedback,
      CognitiveDomain.ClientReflection,
    ],
  },
  {
    title: "TRANSITION",
    content: [CognitiveDomain.Transition],
  },
  {
    title: "EXECUTIVE FUNCTION",
    content: [
      CognitiveDomain.ThoughtOrganization,
      CognitiveDomain.ReasoningLogic,
      CognitiveDomain.ProblemSolving,
      CognitiveDomain.PlanningAndOrganization,
    ],
  },
  {
    title: "MEMORY",
    content: [
      CognitiveDomain.ShortTermMemory,
      CognitiveDomain.LongTermMemory,
      CognitiveDomain.AuditoryProcessing,
      CognitiveDomain.ProceduralMemory,
    ],
  },
  {
    title: "ATTENTION AND CONCENTRATION",
    content: [CognitiveDomain.AttentionAndConcentration],
  },
  {
    title: "LANGUAGE",
    content: [CognitiveDomain.ExpressiveLanguage, CognitiveDomain.ReceptiveLanguage],
  },
];
